import React from 'react'
import './Modals.css'
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import ContactUsModal from "./ContactUsModal";
import RdvModal from "./RDVModal";
import {modal_rdv, services} from '../../constants'
export default function Modals() {
    return (
        <div className='modals'>
            {/*<div className='modals__contact'>*/}
            {/*  <Card variant='elevation'>*/}
            {/*      <SimpleModal>*/}
            {/*        <Contact/>*/}
            {/*      </SimpleModal>*/}
            {/*  </Card>*/}
            {/*</div>*/}
            {/*<div className='modals__rdv'>*/}
                {/*<Paper variant="outlined">*/}
                {/*  <SimpleModal>*/}
                {/*    <Rdv/>*/}
                {/*  </SimpleModal>*/}
                {/*</Paper>*/}
            <ContactUsModal title={services.action} />
            <RdvModal title={modal_rdv.rdv} />
            {/*</div>*/}
        </div>
    )
}


function getModalStyle() {


  return {
    top: `45%`,
    left: `45%`,
    transform: `translate(-45%, -45%)`,
  };
}

const useStyles = makeStyles((theme) => ({
  paper: {
    position: 'absolute',
    width: 500,
    backgroundColor: theme.palette.background.paper,
    border: '2px solid red',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    [theme.breakpoints.down('md')] : {
      width: '80%',
      display:'flex',
     
    }
   
  },
}));

export function SimpleModal({title,children}) {
  const classes = useStyles();
  // getModalStyle is not a pure function, we roll the style only on the first render
  const [modalStyle] = React.useState(getModalStyle);
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const body = (
    <div style={modalStyle} className={classes.paper}>
      {children}
     
    </div>
  );

  return (
    <div className={"modal__chunck"}>
      <button className={"modal__btn"} variant='contained' color='secondary' onClick={handleOpen}>
        {title}
      </button>
      <Modal
      style={{display:'flex'}}
        open={open}
        onClose={handleClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        {body}
      </Modal>
    </div>
  );
}
